
  import { mapState, mapGetters } from 'vuex'
  import { validateTRC20Address } from '~/utils/validate-crypto-address'
  export default {
    data() {
      return {
        addBankAccountModel: false,
        addCryptWalletModal: false,
        formCryptoValid: false,
        cryptoForm: {},
        createCryptoWalletLoading: false,
        editBankData: {}
      }
    },
    computed: {
      ...mapState({
        player: state => state.player.player,
        playerCryptoWallets: state => state.themes['player-bank'].playerCryptoWallets,
        operationSetting: state => state.settings.operationSetting,
        cryptoWalletAddressList: state => state.settings.cryptoWalletAddressList
      }),
      ...mapGetters({
        loading: 'themes/player-bank/loading',
        banks: 'banks/banks',
        bankAccount: 'themes/player-bank/bankAccount'
      }),
      accountLimitExceeded() {
        if (this.bankAccount?.player_bank_accounts?.length >= 5) return true
        return false
      },
      cryptoWalletExceed() {
        if (this.playerCryptoWallets.length >= 5) return true
        return false
      }
    },
    watch: {
      async addBankAccountModel(value) {
        if (value) {
          await this.$store.dispatch('banks/banks', {
            country_code: this.player.country_code
          })
        }
      }
    },
    mounted() {
      this.$store.dispatch('themes/player-bank/playerCryptoWallet')
    },
    methods: {
      editBank(item) {
        this.editBankData = item
        this.addBankAccountModel = true
      },
      closeBankAccountDialog() {
        this.$refs?.refBank?.reset()
        this.editBankData = {}
        this.addBankAccountModel = false
      },
      onAddBankAccount() {
        if (this.accountLimitExceeded) {
          this.$toast.error(this.tr(this.FRONTEND_ERROR_CODES.bankAccountLimitExceeded))
          return null
        }
        this.addBankAccountModel = true
      },
      onAddCryptoWallet() {
        this.addCryptWalletModal = true
        this.$store.dispatch('settings/getCryptoWalletAddressList')
      },
      async onCreateCryptoWallet() {
        this.$refs?.refCrypto?.validate()
        if (!this.formCryptoValid) return

        this.createCryptoWalletLoading = true
        const dispatchUrl = this.cryptoForm.id
          ? 'themes/player-bank/updatePlayerCryptoWallet'
          : 'themes/player-bank/createPlayerCryptoWallet'

        const createResponse = await this.$store.dispatch(dispatchUrl, {
          ...this.cryptoForm
        })
        if (createResponse) {
          this.addCryptWalletModal = false
          if (this.cryptoForm.id) {
            this.$toast.success(this.tl('updateSuccessful'))
          } else {
            this.$toast.success(this.tl('createSuccessful'))
            if (this.playerCryptoWallets?.length === 0) await this.$store.dispatch('player/profile')
          }
          this.$refs.refCrypto.reset()
        }
        this.createCryptoWalletLoading = false
      },
      validateTRC20Address(address) {
        const isValid = validateTRC20Address(address)
        return isValid
      },
      onDisplayEditCryptoModal(item) {
        this.cryptoForm.id = item.id
        this.cryptoForm.network = item.network
        this.cryptoForm.wallet_address = item.wallet_address
        this.cryptoForm.currency = item.currency

        this.onAddCryptoWallet()
      },
      onCloseCryptoModal() {
        delete this.cryptoForm.id
        this.$refs.refCrypto.reset()
        this.addCryptWalletModal = false
      }
    }
  }
